import { useSelector } from 'react-redux';
import { selectUserInfoData } from '../../../reducers/userInfoReducer';
import { useDeployButtonContext } from './DeployButtonContext';
import { useMemo } from 'react';
import { AutomationFiltersTypesMap } from '../../Automations/filters/filtersTypes';
import { FilterComponentType, FilterToggleItem } from '../filters/filters-renderer/types';

export const useShouldRequestToDeploy = (crmOrgId: string) => {
  const { notifyAdmin, deploy } = useDeployButtonContext().permissions;
  const userInfo = useSelector(selectUserInfoData);
  const permissions = userInfo?.permissionsByCrmOrgId?.[crmOrgId] || [];
  return permissions.includes(notifyAdmin) && !permissions.includes(deploy);
};

export const useShouldRequestToDeployFilter = (automations: AutomationStructureNew[]) => {
  const hasRequestToDeployAutomations = automations.find((automation) => automation.notifyAdmin);

  const _filter = useMemo(() => {
    if (!hasRequestToDeployAutomations) {
      return;
    }

    const filter: FilterToggleItem = {
      type: FilterComponentType.TOGGLE_FILTER,
      label: 'Show only deployment requests',
      checked: false,
    };
    return {
      [AutomationFiltersTypesMap.deploymentRequest]: filter,
    };
  }, [hasRequestToDeployAutomations]);

  return _filter;
};
